import React, { FunctionComponent } from 'react'
import { useAuth } from '../context/AuthContext'
import MainLayout from './mainLayout'
import WebviewLayout from './webview'
import TouchScreenLayout from './touchscreen'

interface Prop {
  token?: string
}
const Layout: FunctionComponent<React.PropsWithChildren<Prop>> = (props) => {
  const { isWebView, isTouchScreen } = useAuth()

  return (
    isTouchScreen
      ? (
        <TouchScreenLayout>
          {props.children}
        </TouchScreenLayout>
        )
      : isWebView
        ? (
          <WebviewLayout>
            {props.children}
          </WebviewLayout>
          )
        : (
          <MainLayout>
            {props.children}
          </MainLayout>
          )

  )
}

export default Layout
